import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import FooterToolBar from '../../../components/tool/FooterToolBar.vue';
import selectGroupVue from '@/components/commonAdd/selectGroupDyx.vue';
import { Empty } from 'ant-design-vue';
import { getSpecDetailList } from '@/services/cardrecommend';
import { getGoodsVisibleDetail, saveAddEdit } from '@/services/product/goodsVisible.js';
import debounce from 'lodash/debounce';
export default {
  components: {
    StandardTableVue: StandardTableVue,
    FooterToolBar: FooterToolBar,
    selectGroupVue: selectGroupVue
  },
  i18n: require("./i18n-visible"),
  data: function data() {
    var _this = this;
    this.handleSearch = debounce(this.handleSearch, 600);
    var columns = [{
      dataIndex: 'erpCustomerCode',
      title: this.$t('account.dyxNumber')
    }, {
      title: this.$t('account.goodsName'),
      dataIndex: 'erpCustomerName'
    }, {
      title: this.$t('account.status'),
      dataIndex: 'erpCustomerStatus',
      scopedSlots: {
        customRender: 'erpCustomerStatus'
      }
    }, {
      title: this.$t('account.ddz'),
      dataIndex: 'sellerName'
    }, {
      title: this.$t('account.yetai'),
      dataIndex: 'busFormatName'
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      form: {
        groupName: ''
      },
      visible: false,
      loadingSave: false,
      columns: columns,
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['10', '15', '20'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total')).concat(total);
        },
        pageSize: 10,
        current: 1,
        showSizeChanger: true
      },
      total: 0,
      saveData: [],
      sarchValue: '',
      productDataList: [],
      Empty: Empty,
      fetching: false,
      addList: [],
      isDisabled: false,
      saveId: null,
      alreadySelect: []
    };
  },
  created: function created() {
    if (this.$route.query['id']) {
      this.isDisabled = true;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      if (_this2.$route.query['id']) {
        // this.form.groupName = this.$route.query['name']
        _this2.saveId = _this2.$route.query['id'];
        _this2.getGoodsDetail(_this2.saveId);
      }
    });
  },
  computed: {
    data: function data() {
      var _this3 = this;
      if (this.sarchValue == '') {
        return this.saveData;
      } else {
        return this.saveData.filter(function (item) {
          return item.erpCustomerName.indexOf(_this3.sarchValue) !== -1 || item.erpCustomerCode.indexOf(_this3.sarchValue) !== -1;
        });
      }
    }
  },
  methods: {
    addEdit: function addEdit(row) {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.selectModal.visible = true;
      });
    },
    confirmDelete: function confirmDelete(e) {
      this.saveData = this.saveData.filter(function (item) {
        return item.erpCustomerId !== e.erpCustomerId;
      });
      this.alreadySelect = this.saveData.map(function (item) {
        return item.erpCustomerId;
      });
      this.pagination.total = this.saveData.length;
    },
    cancelDelete: function cancelDelete() {},
    save: function save() {
      var _this5 = this;
      var flag = true;
      this.saveData.forEach(function (item) {
        if (item.erpCustomerStatus !== 1) {
          flag = false;
        }
      });
      if (flag) {
        this.$refs.formModel.validate(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
            var params, res;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  if (!valid) {
                    _context.n = 4;
                    break;
                  }
                  params = {
                    productOptionId: Number(_this5.saveId),
                    erpCustomerIds: _this5.saveData.map(function (item) {
                      return item.erpCustomerId;
                    }),
                    type: 2
                  };
                  _this5.loadingSave = true;
                  _context.p = 1;
                  _context.n = 2;
                  return saveAddEdit(params);
                case 2:
                  res = _context.v;
                  console.log(res.data);
                  if (res.data.code == 200) {
                    _this5.$message.success(_this5.$t('public.saveSuccessfully'));
                    _this5.isDisabled = true;
                  }
                case 3:
                  _context.p = 3;
                  _this5.loadingSave = false;
                  return _context.f(3);
                case 4:
                  return _context.a(2);
              }
            }, _callee, null, [[1,, 3, 4]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.$message.error(this.$t('account.message1'));
      }
    },
    goProduct: function goProduct(id) {
      var routeData = this.$router.resolve({
        path: 'productDetail',
        query: {
          id: id
        }
      });
      window.open(routeData.href, '_blank');
      // this.$router.push({path:'productDetail',query:{id: id}})
    },
    handleSearch: function handleSearch(value) {
      var self = this;
      this.productDataList = null;
      this.fetching = true;
      //获取列表
      if (value != null && value.length > 0) {
        getSpecDetailList(value, 0).then(function (res) {
          if (res.data.code == 200) {
            self.productDataList = res.data.data;
            self.fetching = false;
          } else {
            self.$notification.error({
              message: res.data.message
            });
          }
        });
      }
    },
    handleChange: function handleChange(value) {
      this.form.groupName = value.split('-')[0];
      this.saveId = this.productDataList.filter(function (item) {
        return item.content == value;
      })[0].id;
      this.getGoodsDetail();
    },
    getGoodsDetail: function getGoodsDetail() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this6.loadingTable = true;
              _context2.n = 1;
              return getGoodsVisibleDetail(_this6.saveId);
            case 1:
              res = _context2.v;
              try {
                if (res.data.code == 200) {
                  console.log(Array.from(new Set([].concat(_toConsumableArray(res.data.data.erpCustomerList), _toConsumableArray(_this6.saveData)))), 'set');
                  _this6.saveData = res.data.data.erpCustomerList ? Array.from(new Set([].concat(_toConsumableArray(res.data.data.erpCustomerList), _toConsumableArray(_this6.saveData)))) : Array.from(new Set(_this6.saveData));
                  _this6.alreadySelect = _this6.saveData.map(function (item) {
                    return item.erpCustomerId;
                  });
                  _this6.pagination.total = res.data.data.erpCustomerList ? res.data.data.erpCustomerList.length : 0;
                  _this6.form.groupName = res.data.data.productNo;
                }
              } finally {
                _this6.loadingTable = false;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    confirmProduct: function confirmProduct(data) {
      console.log(data, 'data......');
      this.saveData = data;
      this.alreadySelect = data.map(function (item) {
        return item.erpCustomerId;
      });
      this.pagination.total = data.length;
    }
  }
};